<template>
  <div class="index" v-cloak>
    <div class="header acea-row row-center-wrapper">
      <div class="logo"><img :src="logoUrl" /></div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner && banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <a
            v-if="item.product_id && item.product_id.indexOf('http') >= 0"
            :href="item.product_id"
            class="search acea-row row-middle"
          >
            <img :src="item.img" />
          </a>
          <router-link
            v-else
            :to="item.product_id > 0 ? '/detail/' + item.product_id : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.img" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav acea-row">
      <router-link
        :to="item.url ? item.url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.image" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
    <!--<div class="news acea-row row-between-wrapper">-->
    <!--<div class="pictrue"><img src="@assets/images/news.png" /></div>-->
    <!--<div class="swiper-no-swiping new-banner">-->
    <!--<swiper-->
    <!--class="swiper-wrapper"-->
    <!--:options="swiperRoll"-->
    <!--v-if="roll.length > 0"-->
    <!--&gt;-->
    <!--<swiper-slide-->
    <!--class="swiper-slide"-->
    <!--v-for="(item, index) in roll"-->
    <!--:key="index"-->
    <!--&gt;-->
    <!--<router-link-->
    <!--:to="item.wap_url ? item.wap_url : ''"-->
    <!--class="acea-row row-between-wrapper"-->
    <!--&gt;-->
    <!--<div class="text acea-row row-between-wrapper">-->
    <!--<div class="label" v-if="item.show === '是'">最新</div>-->
    <!--<div class="newsTitle line1">{{ item.info }}</div>-->
    <!--</div>-->
    <!--<div class="iconfont icon-xiangyou"></div>-->
    <!--</router-link>-->
    <!--</swiper-slide>-->
    <!--</swiper>-->
    <!--</div>-->
    <!--</div>-->
    <div
      class="specialArea acea-row row-between-wrapper"
      v-if="activityOne.wap_link !== undefined || activity.length"
    >
      <router-link
        :to="activityOne.wap_link ? activityOne.wap_link : ''"
        v-if="activityOne.wap_link !== undefined"
        class="assemble"
      >
        <img :src="activityOne.pic" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>
      <div class="list acea-row row-column-between">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img :src="item.pic" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="wrapper" v-if="info.fastList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">快速选择</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="scroll-product">
        <swiper class="swiper-wrapper" :options="swiperScroll">
          <swiper-slide
            v-for="(item, index) in info.fastList"
            :key="index"
            class="swiper-slide"
          >
            <router-link
              :to="{
                path: '/goods_list',
                query: { id: item.id }
              }"
            >
              <div class="img-box">
                <img :src="item.img" />
              </div>
              <div class="pro-info line1">{{ item.name }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div
      v-if="menusBottomAd.img"
      style="box-sizing: border-box;margin: 0 15px;"
    >
      <router-link
        :to="{
          path:
            menusBottomAd.product_id.indexOf('/') >= 0
              ? menusBottomAd.product_id
              : '/detail/' + menusBottomAd.product_id
        }"
        class="adver"
        ><img :src="menusBottomAd.img"
      /></router-link>
    </div>

    <div
      class="wrapper"
      v-if="info.bastList.length > 0 || info.bastBanner.length > 0"
    >
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/goods_list' }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <a
              v-if="item.product_id && item.product_id.indexOf('http') >= 0"
              :href="item.product_id"
              class="search acea-row row-middle"
            >
              <img :src="item.img" />
            </a>
            <router-link
              v-else
              :to="item.product_id > 0 ? '/detail/' + item.product_id : ''"
              class="search acea-row row-middle"
            >
              <img :src="item.img" />
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
    </div>
    <div class="hotList" v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/goods_list' }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.img" />
            <img
              src="@assets/images/one.png"
              class="numPic"
              v-if="index === 0"
            />
            <img
              src="@assets/images/two.png"
              class="numPic"
              v-else-if="index === 1"
            />
            <img
              src="@assets/images/three.png"
              class="numPic"
              v-else-if="index === 2"
            />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ￥<span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div v-if="lovely.img" style="margin-top:20px">
      <a
        v-if="lovely.product_id && lovely.product_id.indexOf('http') >= 0"
        :href="lovely.product_id"
        class="search acea-row row-middle"
      >
        <img :src="lovely.img" width="100%" />
      </a>
      <router-link
        v-else
        :to="{
          path: lovely.product_id > 0 ? '/detail/' + lovely.product_id : ''
        }"
        class="adver"
        ><img :src="lovely.img"
      /></router-link>
    </div>
    <div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首发新品<span class="new font-color-red">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/goods_list' }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="img-box">
                <img :src="item.img" />
              </div>
              <div class="pro-info line1">{{ item.title }}</div>
              <div class="money font-color-red">￥{{ item.price }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!--    <wx-open-launch-weapp-->
    <!--            username="gh_f81cab2ba100"-->
    <!--            path="pages/ucenter/ucenter.html" >-->
    <!--      <script type="text/wxtag-template"><button class="btn">打开小程序</button></script>-->
    <!--    </wx-open-launch-weapp>-->
    <div class="wrapper" v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促销单品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="'/goods_list'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div>
    <Promotion-good :benefit="benefit"></Promotion-good>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    />
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData } from "@api/public";
import cookie from "@utils/store/cookie";
import { wechatEvevt, shareFail } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { getCoupon } from "@api/user";

import { mapGetters } from "vuex";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow
  },
  props: {},
  data() {
    return {
      beaeUrl: location.host,
      showCoupon: false,
      logoUrl:
        "//aijiutang.oss-cn-beijing.aliyuncs.com/static_img/logo_139x48.png",
      banner: [],
      menus: [],
      menusBottomAd: {},
      roll: [],
      activity: [],
      activityOne: {},
      cacheCouponIds: [],
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: {},
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 3500
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  computed: mapGetters(["isLogin", "userInfo"]),
  mounted() {
    getHomeData()
      .then(res => {
        this.$set(this, "banner", res.data.banner || []);
        this.$set(this, "menus", res.data.menus || []);
        this.$set(this, "roll", res.data.roll || []);
        this.$set(this, "activity", res.data.activity || []);
        this.menusBottomAd = res.data.menusBottomAd || {};
        if (res.data.activity.length) {
          var activityOne = res.data.activity.shift();
          this.$set(this, "activityOne", activityOne);
        }
        res.data.info && Object.assign(this.info, res.data.info);

        this.$set(this, "likeInfo", res.data.likeInfo || []);
        this.lovely = res.data.lovely;
        this.$set(this, "benefit", res.data.benefit || []);
        this.$set(this, "couponList", res.data.couponList || []);
        this.setOpenShare();
        setTimeout(this.getCoupon, 3000);
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    adJump(product_id) {
      if (!product_id) return;

      if (typeof product_id === "number" && !isNaN(product_id)) {
        this.$router.push("/detail/" + product_id);
      } else if (product_id.indexOf("http") >= 0) {
        location.href = product_id;
      }
    },
    getCoupon() {
      getCoupon().then(r => {
        if (!r.data) return;
        let couponIds = cookie.get(HAS_COUPON_WINDOW);
        if (couponIds) {
          couponIds = couponIds.split(",");
        } else {
          couponIds = [];
        }
        couponIds = couponIds.map(item => parseInt(item));
        r.data = r.data.filter(item => {
          let flag = couponIds.includes(item.id);
          if (!flag) couponIds.push(item.id);
          return !flag;
        });
        console.log("couponIds-2", couponIds);
        this.$set(this, "couponList", r.data);

        this.cacheCouponIds = couponIds;
        this.showCoupon = r.data.length;
      });
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, this.cacheCouponIds.join(","), 30);
    },
    setOpenShare() {
      let href =
        location.origin +
        location.pathname +
        "?s_id=" +
        ("" + Math.random()).split(".")[1];
      let configAppMessage = (configAppMessage = {
        desc: "爱灸堂正品保证，好艾条实力造。",
        title: "爱灸堂商城",
        link: href,
        imgUrl: "https://aijiutang.oss-cn-beijing.aliyuncs.com/mark.png?v1"
      });
      if (isWeixin()) {
        if (this.isLogin) {
          let userInfo = this.userInfo || {};
          let shareUser = "";
          if (userInfo.id) {
            shareUser = "share_uid=" + userInfo.id;
          }
          href =
            href.indexOf("?") === -1
              ? href + "?" + shareUser
              : href + "&" + shareUser;
          configAppMessage["link"] = href;
          console.log("configAppMessage", configAppMessage);
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              console.log(res);
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            })
            .finally(() => {
              console.log("分享完成");
              shareFail(configAppMessage).catch(err => {
                console.log("shareFail:err;", err);
              });
            });
        } else {
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            })
            .finally(() => {
              shareFail(configAppMessage).catch(err =>
                console.log("shareFail:err;", err)
              );
            });
        }
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
</style>
